import moment from 'moment';
import range from './range.js';

export const currentYear = moment().format('YYYY');

const yearListOptions = () => range(Number.parseInt(currentYear), Number.parseInt(currentYear) + 10);
export default yearListOptions;
